import * as angular from "angular";

export class CustomPanelService {

  constructor(private $mdPanel) {
  }

  open($event, data: {options?: any, optionsWrapper?: {list?: any[], propertyRef: string}}, selectedId, cb) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('#change-resource-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = selectedId;
    const optionsRef = data?.options;
    const optionsWrapperRef = data?.optionsWrapper;
    // const excludeIdsRef = this.excludeOptions;
    // const ngPlaceholderRef = this.ngPlaceholder;
    // const isOrderedOptionsRef = this.isOrderedOptions;
    // const optionsPrefixRef = this.optionsPrefix;
    // const selectParamsRef = this.selectParams;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'custom';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionsWrapperRef = optionsWrapperRef;
        // this.ngPlaceholderRef = ngPlaceholderRef;
        // this.excludeIdsRef = excludeIdsRef;
        // this.isOrderedOptionsRef = isOrderedOptionsRef;
        // this.selectParamsRef = selectParamsRef;
        // this.optionsPrefixRef = optionsPrefixRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }
        cb(selectedIds)

        // if (!selectedIds?.length) {
        //   this.onChange({values: []});
        // } else {
        //   this.onChange({values: selectedIds});
        // }
        panel.destroy();
      }
    };

    return this.$mdPanel.open(config);
  }

}

angular
  .module('bringoz.admin.commons')
  .service('customPanelService', CustomPanelService);

